<template>
  <section class="section">
    <div class="container">
      <div class="cr_wrapper">
        <div class="feature_image">
          <img
            class="img-fluid"
            alt=""
            :src="require('../assets/images/registration-01.png')"
          />
        </div>
        <div class="cr_item">
          <div class="cr_item_content">
            <h1>Change your password</h1>
            <!--            <h2>or <a href="/register">Get started with Upskill!</a></h2>-->
            <ul class="cr_steps" style="width: 100%;">
              <li class="active"></li>
            </ul>
            <uform style="max-width: 600px">
              <ulabel size="12">
                <uinput
                  placeholder="Password*"
                  type="password"
                  v-model="model.password"
                ></uinput>
              </ulabel>
              <ulabel size="12">
                <uinput
                  placeholder="Confirm Password*"
                  type="password"
                  v-model="model.confirmPassword"
                ></uinput>
              </ulabel>
              <ulabel size="6">
                <ubtn
                  class="mx-auto"
                  @click.prevent.native="changePassword"
                  :loading="btnLoading"
                  >Change Password</ubtn
                >
              </ulabel>
            </uform>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      model: {},
      form: {},
      request_id: "",
      btnLoading: false,
      loading: false
    };
  },
  methods: {
    changePassword() {
      this.btnLoading = true;
      if (
        this.model.password < 8 ||
        this.model.password !== this.model.confirmPassword
      ) {
        this.ErrorAlert(
          "Must must be at least 8 characters long and both fields must match!"
        );
      } else {
        this.$upskill
          .pwFinal(this.request_id, this.model.password)
          .then(() => {
            this.btnLoading = false;
            this.SuccessAlert("Password changed successfully!");
            this.Goto({ name: "login" });
          })
          .catch(() => {
            this.btnLoading = false;
            this.ErrorAlert("This link is expired!");
          });
      }
    }
  },
  created() {
    this.Loaded();
    this.request_id = this.$route.query.id;
    this.$upskill
      .pwCheck(this.request_id)
      .then(() => {
      })
      .catch(() => {
        this.ErrorAlert("This link is expired!");
        this.Goto({name:"home"})
      });
  }
};
</script>

<style scoped>
.signup {
  margin-top: 25px;
  background: #013686 0% 0% no-repeat padding-box;
  display: flex;
  padding: 20px;
  flex-wrap: wrap;
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
}
.form_input {
  width: 100%;
  height: 38px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #728391;
  opacity: 1;
  padding: 10px;
  font-family: "Montserrat", sans-serif;
  margin: 5px 0px;
}
label {
  color: #999;
  font-size: 12px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 10px;
  top: -14px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}
.group {
  position: relative;
  width: 100%;
  margin-top: 20px;
}
.signin-title {
  margin-left: auto;
  margin-right: auto;
  font-family: "Montserrat", sans-serif;
  font-size: 30px;
  letter-spacing: 4px;
  /*letter-spacing: -2.5px;*/
  color: #fff;
}
</style>
